import type { IconSvgObject } from './types';

const PillBottleIcon: IconSvgObject = [
  ["path", { d: "M19 2H5C4.44772 2 4 2.44772 4 3V6C4 6.55228 4.44772 7 5 7H19C19.5523 7 20 6.55228 20 6V3C20 2.44772 19.5523 2 19 2Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18 7H6V20C6 21.1046 6.89543 22 8 22H16C17.1046 22 18 21.1046 18 20V7Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M11 11H6V17H11C11.5523 17 12 16.5523 12 16V12C12 11.4477 11.5523 11 11 11Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default PillBottleIcon;
